import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=496b9080&scoped=true"
import script from "./ProductTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=496b9080&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b9080",
  null
  
)

export default component.exports